import MuiSwitch, { SwitchProps as MuiSwitchProps } from "@mui/material/Switch";

import { TestProps } from "shared/types";

export interface SwitchProps extends MuiSwitchProps, TestProps {}

const Switch = ({ testId, ...props }: SwitchProps) => (
  <MuiSwitch data-testid={testId} {...props} />
);

export default Switch;
